const DEFAULT_CAMERA_POSE = {
    position: [0, 8, 16],
    target: [0, 0, 0],
    fov: 50,
};
export function resolveCameraPose(spaceRenderOptions) {
    return spaceRenderOptions?.camera?.pose ?? DEFAULT_CAMERA_POSE;
}
